import React, { useState } from "react";
import {
  ModalComponent,
  Input,
  FlexContainer,
  CustomLabel,
  SapphireBlueButton, 
} from "@mindmemobile/mm-shared-global"; 
import { CategoriesModel } from "../../../shared/models";


type RenameCategoryPopupProps = {
  category: CategoriesModel;
  onClose: (refresh: boolean) => void;
  onRename: (updatedCategory: CategoriesModel) => void;
};

const RenameCategoryPopup: React.FC<RenameCategoryPopupProps> = ({ category, onClose, onRename }) => {
  const [newName, setNewName] = useState(category.name);
  const [isProcessing, setIsProcessing] = useState(false);

  const handleRename = () => {
      setIsProcessing(true);
      const updatedCategory = new CategoriesModel({ ...category, name: newName });
      onRename(updatedCategory);
      setIsProcessing(false);
  };

  return (
      <ModalComponent
          title="Rename Category"
          onClose={() => onClose(false)}
          showFooter
          wrapperWidth="400px"
          footerContent={
              <FlexContainer justifyContent="center" spacing={15}>
                  <SapphireBlueButton onClick={() => onClose(false)}>Cancel</SapphireBlueButton>
                  <SapphireBlueButton onClick={handleRename} disabled={isProcessing} primary>
                      Rename
                  </SapphireBlueButton>
              </FlexContainer>
          }
      >
          <FlexContainer padding="10px" fxLayout="column" justifyContent="center" alignItems="center" spacing={20}>
              <CustomLabel>
                  Rename <span style={{ fontWeight: 'bold' }}> {category.name} </span> to
              </CustomLabel>
              <Input
                  value={newName}
                  onChange={(e) => setNewName(e.target.value)}
                  placeholder="Enter new category name"
                  className="styled-input"
                  type={'text'}
              />
          </FlexContainer>
      </ModalComponent>
  );
};

export default RenameCategoryPopup;
